'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var web3_js = require('@solana/web3.js');

class Pda extends web3_js.PublicKey {
  /** The bump used to generate the PDA. */

  constructor(value, bump) {
    super(value);
    this.bump = bump;
  }
  static find(programId, seeds) {
    const [publicKey, bump] = web3_js.PublicKey.findProgramAddressSync(seeds, programId);
    return new Pda(publicKey, bump);
  }
}

exports.Pda = Pda;
//# sourceMappingURL=Pda.cjs.map
